"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyFundDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var MyFundDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyFundDetail, _super);
    function MyFundDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的基金详情页';
        _this.code = '106013';
        _this.desc = '我的基金详情页';
        _this.requestParams = new zl_1.MyFundDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyFundDetail;
}(service_1.BaseService));
exports.MyFundDetail = MyFundDetail;
//# sourceMappingURL=myFundDetail.js.map